import { Input } from "antd";
import type { FormItemProps, InputProps } from "antd";
import type { CSSProperties, FC } from "react";
import { useMemo } from "react";
import { FormItem } from "./FormItem";
import { useTranslation } from "utils";

export interface FormInputProps
  extends Omit<FormItemProps, "name">,
    Pick<
      InputProps,
      | "type"
      | "size"
      | "placeholder"
      | "disabled"
      | "variant"
      | "prefix"
      | "suffix"
      | "onChange"
      | "onPressEnter"
      | "onBlur"
      | "readOnly"
      | "showCount"
      | "maxLength"
      | "allowClear"
      // | "className"
      | "value"
    > {
  name: string | number | (string | number)[];
  formItemStyle?: CSSProperties;
  showLabel?: boolean;
  inputClassName?: string;
}
export const FormInput: FC<FormInputProps> = ({
  name,
  label,
  rules,
  type,
  size,
  placeholder,
  formItemStyle,
  disabled,
  variant,
  prefix,
  suffix,
  onChange,
  onPressEnter,
  onBlur,
  readOnly,
  showLabel = true,
  showCount,
  maxLength = 50,
  allowClear,
  inputClassName,
  value,
  ...props
}) => {
  const { t } = useTranslation("form");
  const mergedRules = useMemo(() => {
    return rules?.concat({ max: maxLength });
  }, [rules, maxLength]);
  return (
    <FormItem
      name={name}
      label={showLabel && label}
      rules={mergedRules}
      style={formItemStyle}
      {...props}
    >
      <Input
        type={type}
        size={size}
        placeholder={placeholder ?? t("pleaseInput", { name: label })}
        disabled={disabled}
        variant={variant}
        prefix={prefix}
        suffix={suffix}
        onChange={onChange}
        onPressEnter={onPressEnter}
        onBlur={onBlur}
        readOnly={readOnly}
        showCount={showCount}
        maxLength={maxLength}
        allowClear={allowClear}
        className={inputClassName}
        value={value}
      />
    </FormItem>
  );
};
